import Hotspot from './Hotspot'

export { Hotspot as default }
